import { render, staticRenderFns } from "./DataBridge.vue?vue&type=template&id=44942ee2"
import script from "./DataBridge.vue?vue&type=script&lang=js"
export * from "./DataBridge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports